import { render, staticRenderFns } from "./WebAppFeedback.vue?vue&type=template&id=b4d26fd4&scoped=true&"
import script from "./WebAppFeedback.vue?vue&type=script&lang=js&"
export * from "./WebAppFeedback.vue?vue&type=script&lang=js&"
import style0 from "./WebAppFeedback.vue?vue&type=style&index=0&id=b4d26fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d26fd4",
  null
  
)

export default component.exports